import { Component, OnInit,TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_Interface, Empty_Calibration_Interface } from 'src/app/Interface/Calibration_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LabService } from 'src/app/Service/Lab/Lab.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-LabExitReview',
  templateUrl: './LabExitReview.component.html',
  styleUrls: ['./LabExitReview.component.scss']
})
export class LabExitReviewComponent implements OnInit {

  Filter_Expert: string = ""
  Filter_DeviceCode: string = ""
  Filter_DeviceSerial: string = ""
  Filter_Code: string = ""

  OperationDsc: string = ""
  page: number = 0;
  InProccessing: boolean = false

  modalRef_Delete: any;

  constructor(
    private Lab_Service: LabService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private modalService: BsModalService
  ) { }


  DataList_Lab: Array<Calibration_Interface> = []
  Data_Seleted_Delete: Calibration_Interface = Empty_Calibration_Interface()
  Data_Seleted_Delete_Status:number

  ngOnInit() {

    this.Nav_Service.CheckValidPage(1152).subscribe(
      data => {
        this.ReadData_Lab()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Lab() {
    this.InProccessing = true
    this.Lab_Service.GetRequestExit().subscribe(
      data => {
        this.DataList_Lab = data
        this.InProccessing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record:Calibration_Interface,Status:number) {
    this.Data_Seleted_Delete = Record
    this.OperationDsc=""
    this.Data_Seleted_Delete_Status = Status
    this.modalRef_Delete = this.modalService.show(template);
  }

  Change_Filter() {
    this.page = 0
  }

  AnswerReview(){
    this.InProccessing=true
    this.modalRef_Delete.hide()
    this.Lab_Service.AnswerReviewExit(this.Data_Seleted_Delete.id,
      this.Data_Seleted_Delete_Status,
      this.OperationDsc).subscribe(
      data=>{
        this.InProccessing = false

        this.ReadData_Lab()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

}
